import type { EvidenceTypeFilter } from 'security-app/components/Investigations/Details/TimelineSegment/types';

export const severityAllFilter = 'all';

export const typeAllFilter = 'all';
export const evidenceTypeEvent = 'event';
export const evidenceTypeLog = 'log';

export const evidenceTypeOptions: Array<{ value: EvidenceTypeFilter; label: string }> = [
  { value: typeAllFilter, label: 'All' },
  { value: evidenceTypeEvent, label: 'Events' },
  { value: evidenceTypeLog, label: 'Messages' },
];

export const EVIDENCE_CAROUSEL_ID = 'investigation-evidence-overview';
